import { render } from "./markettrendsarticlecard.vue?vue&type=template&id=54e8053c"
import script from "./markettrendsarticlecard.js?vue&type=script&lang=js"
export * from "./markettrendsarticlecard.js?vue&type=script&lang=js"

import "./markettrendsarticlecard.vue?vue&type=style&index=0&id=54e8053c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__